/*
 * @Descripttion: 科研合作
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-20 16:50:17
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-03-31 16:32:16
 */

const scienceResearch = {
  title: 'Research Collaboration',
  des: '',
  intelligence: {
    title: 'AI Leading Intelligent Healthcare',
    des: 'ArteryFlow Technology has accumulated profound technical expertise in computational simulation, AI, and medical imaging processing. The core team members are experts in both technology and clinical practice.',
    list: [
      {
        title: 'Professional Technical Team',
        des: 'ArteryFlow Technology has a group of experienced experts in computational simulation, AI, and medical imaging processing. We have profound technical accumulation and hundreds of papers published.'
      },
      {
        title: 'Reliable Cloud Platform',
        des: 'A robust and reliable server platform ensures stable system operation. Efficient and durable cloud servers support the simultaneous operation of multiple centres. Professional artificial intelligence processing hardware provides superior computing power and processing performance.'
      },
      {
        title: 'Personalized Research Services',
        des: 'Through computer vision and deep learning methods, ArteryFlow Technology provides  precise data analysis services, improves diagnostic accuracy, and formulates personalized treatment plans for cerebrovascular diseases, enhancing patient treatment outcomes.'
      }
    ]
  },
  field: {
    title: 'Research Collaboration Fields',
    des: 'The founding team members have world-class research experience in the field of cardiovascular and cerebrovascular diseases for over 20 years. ArteryFlow Technology has established in-depth clinical collaborations with hundreds of cardiovascular and cerebrovascular medical institutions domestically and internationally and has published hundreds of papers.',
    list: [
      {
        title: 'Clinical Departments & Physical Examination Centers',
        des: "ArteryFlow Technology's AI algorithms and technical teams welcome innovative collaboration ideas from various hospital clinical departments, expanding our current cardiovascular disease technologies to other clinical departments, verifying new concepts through clinical trials, and innovating diagnosis and treatment technologies. We also provide non-invasive detection of various cardiovascular diseases for physical examination centres, suitable for general population screening or high-risk population screening."
      },
      {
        title: 'Peer companies',
        des: 'ArteryFlow Technology welcomes collaboration with companies in related fields. Our AI product software can be paired with large imaging devices (CT, MRI, etc.) to provide intelligent workstations for disease screening, prioritize cases, and even assist doctors in producing valuable diagnostic reports to improve efficiency, reduce labor costs, maximize the value of hardware equipment, and enhance the efficiency of diagnosis.'
      }
    ]
  },
  intention: {
    title: 'Contact us',
    des: 'We welcome collaboration with professionals in the medical industry to jointly apply artificial intelligence technology to the medical field and conduct cutting-edge academic research.',
    form: {
      name: 'Your Name',
      company: 'Company Name',
      contact: 'Contact Information',
      content: 'Collaboration Content',
      btn: 'Submit'
    }
  }
}

export default scienceResearch
